import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

// Default settings fallback
const DEFAULT_SETTINGS = {
  eventName: 'Old Skool Hangout',
  eventDate: 'December 15, 2025',
  eventTime: '6:00 PM - 11:00 PM',
  eventLocation: 'Kanu Ndubisi park, Mobolaji Johnson Ikeja'
};

/**
 * Fetch event settings from Firestore
 * @returns {Promise<Object>} Event settings object
 */
export const getEventSettings = async () => {
  try {
    const settingsRef = doc(db, 'settings', 'event');
    const settingsDoc = await getDoc(settingsRef);
    
    if (settingsDoc.exists()) {
      return settingsDoc.data();
    }
    
    // Return default settings if not found
    return DEFAULT_SETTINGS;
  } catch (error) {
    console.error('Error fetching event settings:', error);
    // Return default settings on error
    return DEFAULT_SETTINGS;
  }
};

/**
 * Subscribe to real-time updates of event settings
 * @param {Function} callback - Function to call when settings change
 * @returns {Function} Unsubscribe function
 */
export const subscribeToEventSettings = (callback) => {
  try {
    const settingsRef = doc(db, 'settings', 'event');
    
    const unsubscribe = onSnapshot(
      settingsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          callback(snapshot.data());
        } else {
          // Use default settings if document doesn't exist
          callback(DEFAULT_SETTINGS);
        }
      },
      (error) => {
        console.error('Error listening to event settings:', error);
        // Return default settings on error
        callback(DEFAULT_SETTINGS);
      }
    );
    
    return unsubscribe;
  } catch (error) {
    console.error('Error setting up settings listener:', error);
    callback(DEFAULT_SETTINGS);
    // Return a no-op unsubscribe function
    return () => {};
  }
};

/**
 * Get event settings synchronously (for use in components that need immediate values)
 * This should be used with a state management solution or context
 * For now, we'll use the default values
 */
export const getDefaultEventSettings = () => {
  return DEFAULT_SETTINGS;
};

